import React, { useEffect, useState } from 'react';
import '../App.css';

function InternalErrorPage() {
    const [errorMessage, setErrorMessage] = useState("An unknown error occurred.");

    useEffect(() => {
        const message = localStorage.getItem('errorMessage');
        if (message) {
            setErrorMessage(message);
            localStorage.removeItem('errorMessage'); // Clear the error message after displaying
        }
    }, []);

    return (
        <div className='errormessage'>
            Error: InternalErrorPage <br/> {errorMessage}
        </div>
    );
}

export default InternalErrorPage;
